import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import datastore from '@datastore';
import FormControlSelectRow from './form_control_select_row';
import FormControlRow from './form_control_row';

const StateSelect = props =>
  _.has(props.countryStates, props.country) ? (
    <FormControlSelectRow
      {...props}
      options={_.map(props.countryStates[props.country], state => ({
        value: state.code,
        label: state.name,
      }))}
    />
  ) : (
    <FormControlRow {...props} />
  );

StateSelect.propTypes = {
  country: PropTypes.string.isRequired,
  countryStates: PropTypes.shape({}),
};

const mapStateToProps = state => ({
  countryStates: datastore.selectors.getStatesByCountry(state),
});

export default connect(mapStateToProps)(StateSelect);
